/**
 * @generated SignedSource<<ce46f14c6b1b65eaa0ee4a0e675ad2bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CurrencyType = "CAD" | "EUR" | "USD" | "%future added value";
export type DataGranularity = "MONTHLY" | "WEEKLY" | "%future added value";
export type FbAccessTokenType = "LP" | "%future added value";
export type Role = "ADMIN" | "APPROVER" | "EDITOR" | "%future added value";
export type SetupAccountRequest = {
  brands: ReadonlyArray<SetupBrandInput>;
  featureFlagIds?: ReadonlyArray<string> | null;
  metaBusinessAccountId: string;
  name: string;
  users?: ReadonlyArray<SetupUserInput> | null;
};
export type SetupBrandInput = {
  currencyType?: CurrencyType | null;
  dataGranularity?: DataGranularity | null;
  fbAccessTokenType?: FbAccessTokenType | null;
  featureFlagIds?: ReadonlyArray<string> | null;
  insightsThreshold?: number | null;
  metaAdAccountExternalId: string;
  minAdSpend?: number | null;
  name: string;
};
export type SetupUserInput = {
  accountRoles?: ReadonlyArray<Role> | null;
  brandAccess?: ReadonlyArray<SetupBrandAccessInput> | null;
  email: string;
  featureFlagIds?: ReadonlyArray<string> | null;
  firstName?: string | null;
  isOwner?: boolean | null;
  lastName?: string | null;
};
export type SetupBrandAccessInput = {
  brandIndex: number;
  roles: ReadonlyArray<Role>;
};
export type AccountSetupWizardMutation$variables = {
  input: SetupAccountRequest;
};
export type AccountSetupWizardMutation$data = {
  readonly setupAccount: {
    readonly id: string;
  };
};
export type AccountSetupWizardMutation = {
  response: AccountSetupWizardMutation$data;
  variables: AccountSetupWizardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminAccount",
    "kind": "LinkedField",
    "name": "setupAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountSetupWizardMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountSetupWizardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "00abe12c6f26dd64c63adf9e220b6e25",
    "id": null,
    "metadata": {},
    "name": "AccountSetupWizardMutation",
    "operationKind": "mutation",
    "text": "mutation AccountSetupWizardMutation(\n  $input: SetupAccountRequest!\n) {\n  setupAccount(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "13bfa04837e8db38de866b3ecd0bc442";

export default node;
